import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { AuthService } from '../auth.service';
import { LoginResponse } from '../../enums/login.response.enum';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = async (route, state) =>
{
    const router: Router = inject(Router);

    // Check the authentication status
    const loginResponse = await inject(AuthService).isLoggedIn();
    switch (loginResponse) {
        // If the user is not authenticated...
        case LoginResponse.LOGIN_ERROR:
        case LoginResponse.LOGOUT_SUCCESS:
        case LoginResponse.SERVER_ERROR:
            // Allow the access
            return true;
        case LoginResponse.LOGIN_SUCCESS:
            // Redirect to the root
            await router.navigate(['']);
            // Prevent the access
            return false;
    }
};
